import { render, staticRenderFns } from "./warehouse-packing-list.vue?vue&type=template&id=60e20278&scoped=true"
import script from "./warehouse-packing-list.vue?vue&type=script&lang=js"
export * from "./warehouse-packing-list.vue?vue&type=script&lang=js"
import style0 from "./warehouse-packing-list.vue?vue&type=style&index=0&id=60e20278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e20278",
  null
  
)

export default component.exports